<template>
  <div>
    <div class="d-flex justify-content-between flex-column">
      <div class="d-flex">
        <AppSearchInput
          class="my-auto"
          v-model="search"
          :label="$t('search') + ':'"
          :placeholder="$t('search') + '...'"
          @callback="onFilter"
        />

        <b-button
          v-b-modal.modal-add-report
          class="ml-auto d-flex mt-auto"
          size="md"
          variant="primary"
        >
          <feather-icon icon="PlusIcon" size="15" />
        </b-button>
      </div>

      <b-table
        v-if="!isLoading"
        id="user-table"
        class="px-1 rounded mt-1 bg-light-secondary"
        :items="GET_REPORT_LIST.results"
        :fields="fields"
        show-empty
        :tbody-tr-class="['tableRowClass']"
        small
        responsive
        :empty-text="$t('empty_text')"
      >
        <template #head()="props">
          <span>{{ $t(props.label) }}</span>
        </template>
   
        <template #cell(created_at)="props">
          <span>{{ $dayjs(props.item.created_date).format("DD.MM.YYYY") }}</span>
        </template>

        <template #cell(actions)="props">
          <div class="d-flex align-items-center justify-content-center">
            <b-button
              class="mr-1"
              v-b-modal.modal-view-report-pto
              :title="$t('watch')"
              size="sm"
              variant="primary"
              @click="onClickView(props.item.id)"
            >
              <feather-icon icon="ChevronsRightIcon" size="15" />
            </b-button>

            <b-button
              class="mr-1"
              size="sm"
              variant="success"
              @click="onClickViewPto(props.item.id)"
            >
              <feather-icon icon="PlusIcon" size="15" />
            </b-button>

            <b-button
              :title="$t('excel')"
              size="sm"
              variant="success"
              @click="onClickDownloadPto(props.item.id)"
            >
              <feather-icon icon="DownloadIcon" size="15" />
            </b-button>
          </div>
        </template>
      </b-table>

      <b-card v-else>
        <Loader />
      </b-card>
    </div>
    <Pagination
      :params="filter"
      :rows="GET_REPORT_LIST.count"
      @refresh="pagRefresh"
    />


    <addReportModal />
    <ViewReportPto />
  </div>
</template>

<script>
import { BCol, BRow, BCard, BButton, BTable } from "bootstrap-vue";

import AppSearchInput from "@/components/AppSearchInput.vue";
import addReportModal from "./components/addReportModal.vue";
import ViewReportPto from "./components/ViewReportPto.vue";
import { mapActions, mapGetters } from "vuex";
import Pagination from "@/components/Pagination.vue";
import loader from "@/mixins/loader";
import Loader from "@/components/Loader.vue";
import moment from "moment"


export default {
  components: {
    BCol,
    BRow,
    BCard,
    BButton,
    BTable,
    Loader,
    Pagination,
    AppSearchInput,
    addReportModal,
    ViewReportPto,
  },
  data() {
    return {
      isLoading: false,
      search: null,
      filter: {
        page: 1,
        page_size: 10,
      },
      fields: [
        {
          label: "№",
          key: "id",
          thClass: "tableHeadClass",
        },
        {
          label: "title",
          key: "title",
          thClass: "tableHeadClass",
        },

        {
          label: "date",
          key: "created_at",
          thClass: "tableHeadClass",
        },
        {
          label: "actions",
          key: "actions",
          thClass: "tableHeadClass",
        },
      ],
    };
  },
  mixins: [loader],
  computed: {
    ...mapGetters("contacts", ["GET_REPORT_LIST"]),
  },
  methods: {
    ...mapActions("contacts", ["FETCH_ALL_REPORT_LIST", "FETCH_ONE_REPORT"]),
    ...mapActions("pto", ["FETCH_REPORT_EXCEL_ONE"]),
    async onFilter(search) {
      this.filter.page = 1;
      this.isLoading = true;
      await this.FETCH_ALL_REPORT_LIST({ ...this.filter, search: search });
      this.isLoading = false;
    },
    async pagRefresh() {
      this.isLoading = true;
      await this.FETCH_ALL_REPORT_LIST({ ...this.filter, ...this.search });
      this.isLoading = false;
    },
    onClickViewPto(id) {
      this.$router.push(`/report/${id}`);
    },
    onClickView(id) {
      this.FETCH_ONE_REPORT(id);
    },
    onClickDownloadPto(id) {
      this.FETCH_REPORT_EXCEL_ONE(id).then((res) => {
        const url = window.URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,",
          })
        );
        const date = new Date();
        const fullDate = moment(date).format("DD-MM-YYYY");
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fullDate);
        document.body.appendChild(link);
        link.click();
      });
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.FETCH_ALL_REPORT_LIST({ ...this.filter, ...this.search });
    this.isLoading = false;
  },




  
};
</script>

<style lang="scss">
.echarts {
  min-height: 600px;
}




#user-table {
  border-collapse: separate;
  border-spacing: 0 1rem;
}

#user-table .tableRowClass {
  background: white;
  transform: translateY(5px);
  transition: all 0.5s ease-in-out;
  text-align: center;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

  td {
    border-top: 0;
    padding: 20px !important;

    &:first-child {
      border-top-left-radius: 0.5rem;
      border-bottom-left-radius: 0.5rem;
    }

    &:last-child {
      border-top-right-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }
  }
}

#user-table .tableRowClass:hover {
  transform: translateY(0);
}

#user-table .tableHeadClass {
  background: none !important;
  border: none !important;
}

#user-table .tableRowClass:hover {
  .tableTitle {
    color: #7367f0 !important;
  }
}

.tableHeadClass {
  text-align: center;
  padding-left: 0 !important;
}
</style>
